import { removeSpaces } from '@src/utils/removeSpaces'

export const isValidPhone = (phone: string) => {
  const phoneNumber = removeSpaces(phone)
  const validation = /^[+]?\d{4,16}$/
  if (!phoneNumber.match(validation)) {
    return false
  }
  return true
}
